import React from 'react';
import PropTypes from 'prop-types';

import { SimpleLargeButton } from '../../../common/simple-large-button';

const IPropTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  disabled: false,
};

const AddToListButton = props => (
  <SimpleLargeButton
    {...props}
    className={props.className}
  >
    {
      props.disabled
        ? 'En favoritos'
        : 'Agregar a favoritos'
    }
  </SimpleLargeButton>
);

AddToListButton.propTypes = IPropTypes;
AddToListButton.defaultProps = defaultProps;

export { AddToListButton };



// WEBPACK FOOTER //
// ./src/pages/product-detail/add-to-list-button/AddToListButton.jsx